/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import PropTypes from "prop-types";
import { 
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Slide,
  Typography
} from "@material-ui/core/"
import CloseIcon from '@material-ui/icons/Close'
import ConfirmationDialogJSS from "./ConfirmationDialogJSS";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ConfirmationDialog = ({ ...props }) => {
  const classes = ConfirmationDialogJSS();
  const { children, title, type, actions, open, close, buttonLabels, hasSecondaryButton, maxWidth, divider, noButton, ...additionalProps } = props;
  
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={actions.onClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      maxWidth={maxWidth ?? "xs"}
      {...additionalProps}
    >
      <DialogTitle id="simple-dialog-title" className={classes.dialogTitle} disableTypography>
        <Typography variant="h2">{title}</Typography>
        <IconButton aria-label="Close" className={classes.closeButton} onClick={actions.onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      {divider && <Divider />}
      <DialogContent>{children}</DialogContent>
      <DialogActions className={classes.dialogTitle}>
        {hasSecondaryButton && (
          <Button
            variant="outlined"
            color="primary"
            className={classes.button}
            onClick={actions.onClose}
          >
            {buttonLabels.onCloseLabel}
          </Button>
        )}
        {!noButton &&
          <Button onClick={actions.onSuccess} color={type} variant="contained" className={classes.button} size="large">
            {buttonLabels.onSuccessLabel}
          </Button>
        }
      </DialogActions>
    </Dialog>
  );
};

ConfirmationDialog.defaultProps = {
  type: "default",
  hasSecondaryButton: false,
  divider: true,
  noButton: false
};

ConfirmationDialog.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,  
  buttonLabels: PropTypes.exact({
    onCloseLabel: PropTypes.string,
    onSuccessLabel: PropTypes.string,
  }).isRequired,
  type: PropTypes.string,
  open: PropTypes.bool.isRequired,
  actions: PropTypes.exact({
    onClose: PropTypes.func,
    onSuccess: PropTypes.func,
  }).isRequired,
  hasSecondaryButton: PropTypes.bool,
  divider: PropTypes.bool,
  noButton: PropTypes.bool,
};

export default ConfirmationDialog;
